export const FieldID = {
  guideContainer: {
    introHeader: {
      title: "introHeaderTitle",
      subtext: "introHeaderSubtext",
      nextStepText: "introHeaderNextStepText",
    },
    estimatedTimeHeader: {
      numSteps: "estimatedNumSteps",
      numStepsIcon: "bulletListImage",
      estimatedTime: "estimatedTimeToComplete",
      estimatedTimeIcon: "clockImage",
    },
    expertHelpContent: {
      buttonText: "expertHelpButtonText",
      title: "expertHelpTitle",
      subtext: "expertHelpSubtext",
      secondaryButtonText: "expertHelpSecondaryButtonText",
      supportNumber: "expertHelpSupportNumber",
      icon: "expertHelpIcon",
    },
    tipBox: {
      tipBeforeSetupWifi: "tipBeforeSetupWifi",
      makeSureConnectedThreeSteps: "makeSureConnectedThreeSteps",
      useGoogleAccountNewPhone: "useGoogleAccountNewPhone",
      iphoneToSamsungLostData: "iphoneToSamsungLostData",
      samsungToIphoneLostData: "samsungToIphoneLostData",
      makeSureConnectedToWifi: "makeSureConnectedToWifi",
      makeSurePhoneFullyCharged: "makeSurePhoneFullyCharged",
      chargeBothPhonesAndBringAdapter: "chargeBothPhonesAndBringAdapter",
      tipUseGoogleAccountToSetupPhone: "tipUseGoogleAccountToSetupPhone",
      simCardCautionText: "simCardCautionText",
      simBatteryOrSDCardNotAccessible: "simBatteryOrSDCardNotAccessible",
      tipSIMNotAccessible: "tipSIMNotAccessible",
      tipReturnOldDevice: "tipReturnOldDevice",
      tipTelusReturnOldDevice: "tipTelusReturnOldDevice",
      icon: "bellImage",
      iconV2: "lightbulbImage",
      exclamationPointIcon: "exclamationPointIconImage",
      commonActivateIMessageTipBox: "turnOffIMessageFaceTime",
      iPhone14SetupBeforeYouStartActivate:
        "iPhone14SetupBeforeYouStartActivate",
      iPhone14SetupBeforeYouStartActivateHeading2:
        "iPhone14SetupBeforeYouStartActivateHeading2",
      iPhone14SetupTipBoxDefaultImage: "iPhone14SetupTipBoxDefaultImage",
      iPhone14SetupBeforeYouStartWifi: "iPhone14SetupBeforeYouStartWifi",
      iPhone14ActivationTipBox: "iphone14ActivationTipBox",
      iPhone14SetupNewPhoneNearby: "iPhone14SetupNewPhoneNearby",
      beforeSamsungSetup: "beforeSamsungSetup",
    },
    introduction: {
      text: "guideIntroductionText",
    },
    activationForm: {
      pSIMTitle: "attPSimTitleText",

      titleText: "attActivationPrompt",
      passcodeHelpHeader: "attAccountPasscodeHelpPrompt",
      passcodeHelpContent: "attAccountPasscodeHelpSteps",

      userInputTitle: "attActivateUserInputTitle",
      userInputSubtitle: "attActivateUserInputSubtitle",
      userInputPrimaryButtonText: "attActivateUserInputPrimaryButtonText",
      userInputPrimaryButtonVariant: "default",

      activateSuccessTitle: "attActivateSuccessTitle",
      activateSuccessSubtitle: "attActivateSuccessSubtitle",
      activateSuccessPSimSubtitle: "attActivateSuccessPSimSubtitle",
      activateSuccessImage: "attMiniHighFiveImage",

      activateFailureTitle: "attActivateFailureTitle",
      activateFailureSubtitle: "attActivateFailureSubtitle",
      activateFailureImage: "attActivateFailureImage",
      activateFailureExpertHelp: {
        title: "attActivateFailureExpertHelpTitle",
        subtext: "attActivateFailureExpertHelpSubtext",
        primaryButtonText: "attActivateFailureExpertHelpPrimaryButtonText",
        secondaryButtonText: "attActivateFailureExpertHelpSecondaryButtonText",
        supportNumber: "expertHelpSupportNumber",
      },

      verifyDeviceFailureTitle: "attVerifyDeviceFailureTitle",

      activationTryAgainButtonText: "attActivationTryAgainButtonText",
      activationTryAgainCallback: "attActivationTryAgainCallback",
      activationPhysicalSIMTryAgainCallback:
        "attActivationPhysicalSIMTryAgainCallback",

      installPlanTitle: "attInstallPlanTitle",
      installPlanNotificationStep: {
        text: "attInstallPlanNotificationText",
      },
      installPlanNotificationSubstep: {
        label: "attInstalPlanNotificationLabel",
        text: "attInstallPlanNotificationSubstepText",
        image: "attInstallPlanNotificationSubstepImage",
      },
      pressContinueStep: {
        text: "attPressContinueInstallPlanText",
      },
      pressContinueSubstep: {
        text: "attPressContinueInstallSubstepPlanText",
        image: "attPressContinueSubstepInstallPlanImage",
        linkCallback: "attPressContinueSubstepInstallPlanLinkCallback",
      },

      transferESIMTitle: "attTransferESIMTitle",
      howToTransferESIMText: "attHowToTransferESIMText",
      howToTransferESIMSubsteps: "attHowToTransferESIMSubtext",
      howToTransferESIMImage: "attTransferCellularImage",

      selectNumbersToTransfer: "attSelectNumbersToTransfer",
      followOnscreenInstructions: "attFollowOnscreenInstructions",
      makeCallOnNewIPhone: "attMakeCallOnNewIPhone",
      oldPlanWillDeactivate: {
        text: "attOldPlanWillDeactivate",
        image: "attTransferCellularImage",
      },

      allSetTitle: "attAllSetTitle",
      allSetSubtitle: "attAllSetSubtitle",
      allSetIcon: "attYourAllSetIcon",
      allSetPrimaryButtonText: "attAllSetPrimaryButtonText",
      allSetPrimaryButtonVariant: "default",
      allSetSecondaryButtonText: "attAllSetSecondaryButtonText",
      allSetSecondaryButtonVariant: "outline",

      almostDoneTitle: "attAlmostDoneTitle",
      almostDoneSubtitle: "attAlmostDoneSubtitle",
      almostDoneButtonVarinat: "default",
      almostDoneCallback: "attAlmostDoneCallback",
      almostDoneImage: "attAlmostDoneImage",

      nextStepsTitle: "attActivationNextStepsTitle",
      nextStepsSubtitle: "attActivationNextStepsSubtitle",

      signIntoYourGoogleAccountFlowTitle: "attSignIntoYourGoogleAccountTitle",
      activationSamsungSetup: "attActivationSamsungSetup"
    },
    decisionStep: {
      doYouKnowAppleIdAndPasswordQuestion: "doYouKnowAppleIdAndPassword",
      haveYouWalkedThroughSetupSteps: "haveYouWalkedThroughSetupSteps",
      doYouKnowGooglePassword: "doYouKnowGooglePassword",
      proceedToNextStep: "proceedToNextStep",
      introHeaderGuideIos13: "introHeaderGuideIos13+",
      headerGuideOlderIos: "headerGuideOlderIos",
      decisionOldSimCard: "decisionOldSimCard",
      samsungSetupSteps: "samsungSetupSteps",
      samsungShowInstructionsFor: "samsungShowInstructionsFor",
      yesSteps: {},
      noSteps: {},
    },
    simCardExplanation: {
      questionText: "simCardQuestionText",
      descriptionText: "simCardDescriptionText",
      image: "simCardImage",
      imageDescription: "simCardImageDescription",
    },
    steps: {
      androidAcceptGoogleTerms: {
        text: "androidSetupGoogleServicesTermsAcceptText",
        images: [
          "verizonSetupAndroidGoogleServices",
          "verizonSetupAndroidGoogleServicesTwo",
        ],
      },
      samsungCopyAppsAndDataFromIphone: {
        text: "samsungCopyAppsAndDataFromIphoneText",
        images: [
          "verizonSetupAndroidDontCopy",
          "verizonSetupAndroidCreateAccount",
        ],
      },
      followInstructionsCompleteSetup: {
        text: "followInstructionsCompleteSetup",
      },
      samsungLetsGoScreen: {
        text: "samsungLetsGoScreen",
        images: [
          "verizonSamsungSetupLostPhoneLetsGo",
          "verizonSetupSamsungTerms",
        ],
      },
      samsungCopyAppsData: {
        text: "samsungCopyAppsData",
        images: [
          "verizonSetupSamsungDontCopy",
          "verizonSetupAndroidCreateAccount",
        ],
      },
      turnOffFindMyPhone: {
        text: "turnOffFindMyPhone",
        image: "findMyIphoneIcon",
      },
      turnOffIPhoneStep: {
        text: "turnOffIPhoneStep",
      },
      stepSendUsYourIPhone: {
        text: "stepSendUsYourIphone",
      },
      stepOpenIphoneSettings: {
        text: "stepOpenIphoneSettings",
        image: "iphoneSettingsImage",
      },
      stepSettingsTapYourName: {
        text: "stepSettingsTapYourName",
      },
      stepFindMyIcon: {
        text: "stepFindMyIcon",
        image: "findMyIphoneIcon",
      },
      stepFindMyIphoneOffOn: {
        text: "stepFindMyIphoneOffOn",
      },
      stepFindMyIphoneToggleSwitch: {
        text: "stepFindMyIphoneToggleSwitch",
        image: "iphoneToggleImage",
      },
      stepAppleIdPasswordTurnOff: {
        text: "stepAppleIdPasswordTurnOff",
        image: "findMyTurnOffiPhone",
      },
      stepDisableFindMyIphone: {
        text: "stepDisableFindMyIphone",
      },
      backupiCloudStep: {
        text: "backupToiCloud",
        image: "backupToiCloudImage",
      },
      backupiCloudSelectionStep: {
        text: "selectItemsToBackup",
        image: "iCloudBackupTogglesImage",
      },
      beginiCloudBackupStep: {
        text: "iCloudBeginBackup",
        image: "iCloudBackupNowImage",
      },
      powerOffNewPhoneStep: {
        text: "powerOffNewPhone",
      },
      locateSimCardTrayStep: {
        text: "locateSimCardTray",
        image: "removeSimCardImage",
        imageHeader: "removeSimCardImageHeader",
      },
      insertNewSimCard: {
        text: "insertNewSimCard",
        image: "simCardInsertionImage",
      },
      verizonPhoneActivationStep: {
        text: "verizonPhoneActivationText",
      },
      telusPhoneActivationStep: {
        text: "telusPhoneActivationStep",
      },
      koodoPhoneActivationStep: {
        text: "koodoPhoneActivationStep",
      },
      usCellularPhoneActivationStep: {
        text: "usCellularPhoneActivationStep",
      },
      phoneActivation: {
        text: "phoneActivationText",
        substep: "phoneActivationSubstep",
      },
      coxActivationLink: {
        text: "coxActivationLink",
      },
      openGoogleDriveStep: {
        text: "openGoogleDrive",
        image: "googleDriveImage",
      },
      backupAndResetSamsungStep: {
        text: "backupAndResetSamsung",
        images: [
          "googleDriveMenuImage",
          "googleDriveBackupSettingsImage",
          "googleDriveBackupImage",
        ],
      },
      selectBackupNowStep: {
        text: "selectBackupNow",
        image: "googleDriveBackupNowImage",
      },
      verizonCloudStep: {
        text: "verizonCloudAppDescription",
        image: "verizonCloudStorageIcon",
      },
      turnOnNewPhoneStep: {
        text: "turnOnNewPhone",
        image: "appleWelcomeScreenImage",
      },
      setupWithAppleId: {
        text: "setupWithAppleId",
        image: "appleSetupNewPhoneImage",
      },
      followiPhoneSetupSteps: {
        text: "followiPhoneSetupSteps",
        image: "appleScanQRCodeImage",
      },
      setupFaceAndTouchId: {
        text: "setupFaceAndTouchId",
        image: "appleSetupFaceAndTouchIdImage",
      },
      iphoneTransferYourData: {
        text: "iphoneTransferYourData",
        image: "appleTransferYourDataImage",
      },
      appleSetupQuickStart: {
        text: "appleSetupQuickStartText",
        image: "appleSetupQuickStartImage",
      },
      appleSetupFromBackup: {
        text: "appleSetupFromBackupText",
        image: "appleSetupFromBackupImage",
      },
      appleSetupRestoreFromICloud: {
        text: "appleSetupRestoreFromICloudText",
        image: "appleSetupRestoreFromICloudImage",
      },
      iPhoneSetupLostPhoneTransferApps: {
        text: "iPhoneSetupLostPhoneTransferAppsText",
        image: "iPhoneSetupLostPhoneTransferAppsImage",
      },
      iPhoneSetupLostPhoneSetupAppleId: {
        text: "iPhoneSetupLostPhoneSetupAppleIdText",
        image: "iPhoneSetupLostPhoneSetupAppleIdImage",
      },
      samsungSetupTerms: {
        text: "samsungSetupTermsText",
        images: [
          "samsungSetupTermsImage1",
          "samsungSetupTermsImage2",
          "samsungSetupTermsImage3",
        ],
      },
      samsungSetupCopyAppsandData: {
        text: "samsungSetupCopyAppsandDataText",
        images: [
          "samsungSetupCopyAppsandDataImage1",
          "samsungSetupCopyAppsandDataImage2",
          "samsungSetupCopyAppsandDataImage3",
        ],
      },
      samsungSetupRestoreData: {
        text: "samsungSetupRestoreDataText",
        images: [
          "samsungSetupRestoreDataImage1",
          "samsungSetupRestoreDataImage2",
          "samsungSetupRestoreDataImage3",
          "samsungSetupRestoreDataImage4",
        ],
      },
      samsungSetupLetsGo: {
        text: "samsungSetupLetsGoText",
        images: ["samsungSetupLetsGoImage1", "samsungSetupLetsGoImage2"],
      },
      samsungSetupFollowOnscreenInstructions: {
        text: "samsungSetupFollowOnscreenInstructions",
      },
      androidSetupCopyAppsandDataFromIphone: {
        text: "samsungCopyAppsAndDataFromIphoneText",
        images: [
          "androidSetupGoogleCreateImage1",
          "androidSetupGoogleCreateImage2",
        ],
      },
      androidSetupGoogleServicesTermsAccept: {
        text: "androidSetupGoogleServicesTermsAcceptText",
        images: [
          "androidSetupGoogleServicesTermsAcceptImage1",
          "androidSetupGoogleServicesTermsAcceptImage2",
        ],
      },
      androidSetupFollowOnscreenInstructions: {
        text: "androidSetupFollowOnscreenInstructions",
      },
      androidSetupCopyAppsandData: {
        text: "androidSetupCopyAppsandDataText",
        image: "androidSetupCopyAppsandDataImage",
      },
      androidSetupGoogleAccount: {
        text: "androidSetupGoogleAccountText",
        image: "androidSetupGoogleAccountImage",
      },
      androidSetupContentMovedConfirm: {
        text: "androidSetupContentMovedConfirmText",
        image: "androidSetupContentMovedConfirmImage",
      },
      waitUntilContentTransferred: {
        text: "waitUntilContentTransferred",
        image: "appleWaitUntilTransferCompleteImage",
      },
      findYourAppleId: {
        text: "findAppleId",
        image: "findAppleIdImage",
      },
      resetAppleIdPassword: {
        text: "resetAppleIdPassword",
        image: "resetAppleIdPasswordImage",
      },
      ifTwoFactorEnabled: {
        text: "ifTwoFactorEnabled",
        image: "ifTwoFactorEnabledImage",
      },
      ifTwoFactorDisabled: {
        text: "ifTwoFactorDisabled",
        image: "ifTwoFactorDisabledImage",
      },
      //----------
      findGmailAddress: {
        text: "findGmailAddress",
        image: "googleEmailLoginImage",
      },
      confirmYourAccount: {
        text: "confirmYourAccount",
        image: "googleVerificationCodeImage",
      },
      checkEmailUsernameList: {
        text: "checkEmailUsernameList",
        image: "googleSelectYourAccountImage",
      },
      resetGmailPassword: {
        text: "resetGmailPassword",
        image: "googleAccountRecoveryImage",
      },
      answerSecurityQuestions: {
        text: "answerSecurityQuestions",
        image: "googleAccountRecoverySecurityQuestionsImage",
      },
      turnOnNewPhoneAndFollowSetupSteps: {
        text: "turnOnNewPhoneAndFollowSetupSteps",
        image: "googleCopyAppsAndDataImage",
      },
      tapFromiPhoneDevice: {
        text: "tapFromiPhoneDevice",
        image: "googleSelectAniPhoneImage",
      },
      copyYourDataScreenInstructions: {
        text: "copyYourDataScreenInstructions",
        image: "googleCopyYourDataInstructionsImage",
      },
      signInToGoogleAccount: {
        text: "signInToGoogleAccount",
        image: "googleSignInImage",
      },
      backupToGoogleDriveCompleted: {
        text: "backupToGoogleDriveCompleted",
        image: "googleBackupCompletedImage",
      },
      ///----------------------------------
      useSamsungSmartSwitch: {
        text: "useSamsungSmartSwitch",
        image: "beginSamsungSmartSwitchImage",
      },
      downloadSmartSwitch: {
        text: "downloadSmartSwitch",
        images: [
          "smartSwitchCopyAppsAndDataImage",
          "smartSwitchUseYourOwnDeviceImage",
          "smartSwitchSelectOldDeviceImage",
          "smartSwitchCableConnectionImage",
        ],
      },
      connectToOldPhoneWithUSB: {
        text: "connectToOldPhoneWithUSB",
        image: "smartSwitchConnectCablesImage",
      },
      tapSmartSwitch: {
        text: "tapSmartSwitch",
        image: "smartSwitchOpenApplicationImage",
      },
      tapReceiveData: {
        text: "tapReceiveData",
        images: [
          "smartSwitchTapReceiveDataImage",
          "smartSwitchAllowAccessImage",
        ],
      },
      tapTransferData: {
        text: "tapTransferData",
        images: [
          "smartSwitchChooseWhatToTransferImage",
          "smartSwitchTransferGoogleAccountImage",
          "smartSwitchCopyToNewDeviceImage",
        ],
      },
      enableGoogleServicesAndVerifyAccount: {
        text: "enableGoogleServicesAndVerifyAccount",
        images: [
          "smartSwitchAccountAddedImage",
          "smartSwitchBackupGoogleDriveImage",
          "smartSwitchSignIntoSamsungAccountImage",
          "smartSwitchWaitForTransferImage",
          "smartSwitchVerificationCodeImage",
        ],
      },
      completeSamsungDataTransfer: {
        text: "completeSamsungDataTransfer",
        images: [
          "smartSwitchTapFinishImage",
          "smartSwitchTransferCompletedImage",
        ],
      },
      turnSamsungPhoneOn: {
        text: "turnSamsungPhoneOn",
        image: "turnSamsungPhoneOnImage",
      },
      //-----------------------------
      connectiPhoneToSamsung: {
        text: "connectiPhoneToSamsung",
        image: "selectSmartSwitchImage",
      },
      trustSmartSwitchOnIphone: {
        text: "trustSmartSwitchOnIphone",
        image: "trustThisComputerImage",
      },
      makeSelectionAndTransfer: {
        text: "makeSelectionAndTransfer",
        image: "smartSwitchChooseWhatToBringImage",
      },
      bringStuffFromiCloud: {
        text: "bringStuffFromiCloud",
        image: "smartSwitchBringStuffFromiCloud",
      },
      tapImportToTransferData: {
        text: "tapImportToTransferData",
        image: "smartSwitchChooseWhatToImportImage",
      },
      tapDoneToGoToHomeScreen: {
        text: "tapDoneToGoToHomeScreen",
        image: "smartSwitchAllDoneImage",
      },
      turnOffiMessage: {
        text: "turnOffiMessage",
        image: "smartSwitchturnOffiMessageImage",
      },
      //------------------------
      downloadMoveToiOSApp: {
        text: "downloadMoveToiOSApp",
        image: "moveToiOSImage",
      },
      turnOniPhoneAndMoveDataFromAndroid: {
        text: "turnOniPhoneAndMoveDataFromAndroid",
        image: "iOSTransferAppsAndDataImage",
      },
      enteriPhoneVerificationCode: {
        text: "enteriPhoneVerificationCode",
      },
      selectContentAndTransferData: {
        text: "selectContentAndTransferData",
        image: "iOSSelectDataToTransferImage",
      },
      waitUntilLoadingCompletes: {
        text: "waitUntilLoadingCompletes",
      },
      tapContinueAndFollowRemainingSteps: {
        text: "tapContinueAndFollowRemainingSteps",
      },
      //--------------samsung to android
      copyAppsAndDataInstructions: {
        text: "copyAppsAndDataInstructions",
        images: [
          "googleCopyAppsAndDataImage",
          "smartSwitchUseYourOwnDeviceImage",
          "findOldPhoneCableImage",
          "insertCableIntoOldPhoneImage",
          "connectBothPhonesWithCableImage",
        ],
      },
      signIntoGoogleAccountOnOldPhone: {
        text: "signIntoGoogleAccountOnOldPhone",
        images: [
          "copyDataToNewPhoneImage",
          "checkYourOtherPhoneImage",
          "googleSignInImage",
          "googleEnterPasswordImage",
          "googleAcceptTermsOfServiceImage",
        ],
      },
      selectAppsToTransfer: {
        text: "selectAppsToTransfer",
        images: [
          "gettingReadyToCopyImage",
          "chooseWhatToCopyImage",
          "chooseYourAppsToTransferImage",
          "copyingIsDoneImage",
        ],
      },
      acceptTermsOfService: {
        text: "acceptTermsOfService",
        images: [
          "googleServicesImage",
          "googleLegalTermsImage",
          "enterYourPINImage",
          "reEnterYourPINImage",
          "unlockWithPixelImprintImage",
          "googleContinueSetupImage",
          "yourPhonesAlmostReadyImage",
        ],
      },
      //--------------------------
      removeSimCardAndBattery: {
        text: "removeSimCardAndBattery",
      },
      stepUspsTrackingOnPhoneClaim: {
        text: "stepUspsTrackingOnPhoneClaim",
      },
      placePhoneInEnvelope: {
        text: "placePhoneInEnvelope",
      },
      stepSealedUspsAvoidFee: {
        text: "stepSealedUspsAvoidFee",
      },
      placeOriginalDeviceInPrepaid: {
        text: "placeOriginalDeviceInPrepaid",
      },
      filedServiceRequestLostStolenDevice: {
        text: "filedServiceRequestLostStolenDevice",
      },
      activateBothPhonesPoweredOff: {
        text: "activateBothPhonesPoweredOff",
      },
      activateFailIfDeviceOn: {
        text: "activateFailIfDeviceOn",
      },
      activateLocateSimTrayOldPhone: {
        text: "activateLocateSimTrayOldPhone",
      },
      activateRemoveSimTray: {
        text: "activateRemoveSimTray",
        image: "removeSimCardV2Image",
      },
      activateRepeatRemoveSimProcess: {
        text: "activateRepeatRemoveSimProcess",
      },
      activateTurnOnNewPhone: {
        text: "activateTurnOnNewPhone",
      },
      activateClickActivate: {
        text: "activateClickActivate",
      },
      // ----- iphone14 setup
      iPhone14SetupQuickStartImage: {
        text: "iPhone14SetupTurnOnDevice",
        image: "iPhone14SetupQuickStartImage",
      },
      iPhone14SetupUnlock: {
        text: "iPhone14SetupUnlock",
        image: "iPhone14SetupUnlockImage",
      },
      iPhone14SetupCamera: {
        text: "iPhone14SetupCamera",
        image: "iPhone14SetupCameraImage",
      },
      iPhone14SetupForMe: {
        text: "iPhone14SetupForMe",
        image: "iPhone14SetupForMeImage",
      },
      iPhone14SetupPasscode: {
        text: "iPhone14SetupPasscode",
        image: "iPhone14SetupPasscodeImage",
      },
      iPhone14SetupPasscodeOtherPhone: {
        text: "iPhone14SetupPasscodeOtherPhone",
        image: "iPhone14SetupPasscodeOtherPhoneImage",
      },
      iPhone14SetupPrompts: {
        text: "iPhone14SetupPrompts",
        image: "iPhone14SetupPromptsImage",
      },
      iPhone14SetupPromptsCellular: {
        image: "iPhone14SetupPromptsCellularImage",
      },
      iPhone14SetupTransferData: {
        text: "iPhone14SetupTransferData",
        image: "iPhone14SetupTransferDataImage",
      },
      iPhone14SetupMakeThisYourPhone: {
        text: "iPhone14SetupMakeThisYourPhone",
        image: "iPhone14SetupMakeThisYourPhoneImage",
      },
      iPhone14SetupSiri: {
        text: "iPhone14SetupSiri",
        substep: "iPhone14SetupSiriSubstep",
        image: "iPhone14SetupSiriImage",
      },
      iPhone14SetupComplete: {
        text: "iPhone14SetupComplete",
        image: "iPhone14SetupCompleteImage",
      },
      iPhone14SetupCellular: {
        text: "iPhone14SetupCellular",
        image: "iPhone14SetupCellularImage",
      },
      iPhone14SetupCompleteTestCall: {
        text: "iPhone14SetupCompleteTestCall",
      },
      iPhone14SetupUnableToUseDevice: {
        text: "iPhone14SetupUnableToUseDevice",
      },
      iPhone14SetupFollowPrompts: {
        text: "iPhone14SetupFollowPrompts",
      },
      iPhone14SetupPrepareMove: {
        text: "iPhone14SetupPrepareMove",
      },
      iPhone14SetupConnectedToPower: {
        text: "iPhone14SetupConnectedToPower",
      },
      iPhone14SetupDownloadInBackground: {
        text: "iPhone14SetupDownloadInBackground",
      },
      iPhone14SetupIfUnavailable: {
        text: "iPhone14SetupIfUnavailable",
      },
      iPhone14SetupTurnOnDeviceManual: {
        text: "iPhone14SetupTurnOnDeviceManual",
        image: "iPhone14SetupTurnOnDeviceManualImage",
      },
      iPhone14SetupWifiSelect: {
        text: "iPhone14SetupWifiSelect",
        image: "iPhone14SetupWifiSelectImage",
      },
      iPhone14SetupPrivacy: {
        text: "iPhone14SetupPrivacy",
        image: "iPhone14SetupPrivacyImage",
      },
      iPhone14SetupFaceID: {
        text: "iPhone14SetupFaceID",
        image: "iPhone14SetupFaceIDImage",
      },
      iPhone14SetupChooseHowToTransferData: {
        text: "iPhone14SetupChooseHowToTransferData",
        substep: "iPhone14SetupChooseHowToTransferDataSubstep",
        image: "iPhone14SetupChooseHowToTransferDataImage",
      },
      iPhone14SetupRestoreFromiCloud: {
        text: "iPhone14SetupRestoreFromiCloud",
        image: "iPhone14SetupRestoreFromiCloudImage",
      },
      iPhone14SetupiCloudAppleID: {
        text: "iPhone14SetupiCloudAppleID",
        image: "iPhone14SetupiCloudAppleIDImage",
      },
      iPhone14SetupDontTransfer: {
        text: "iPhone14SetupDontTransfer",
        image: "iPhone14SetupDontTransferImage",
      },
      iPhone14SetupAppleID: {
        text: "iPhone14SetupAppleID",
        image: "iPhone14SetupAppleIDImage",
      },
      iPhone14SetupVerificationCode: {
        text: "iPhone14SetupVerificationCode",
        substep: "iPhone14SetupVerificationCodeSubstep",
        image: "iPhone14SetupVerificationCodeImage",
      },
      iPhone14SetupTermsAndConditions: {
        text: "iPhone14SetupTermsAndConditions",
        substep: "iPhone14SetupTermsAndConditionsSubstep",
        image: "iPhone14SetupTermsAndConditionsImage",
      },
      iPhone14SetupTermsContinue: {
        text: "iPhone14SetupTermsContinue",
        image: "iPhone14SetupTermsContinueImage",
      },
      iPhone14SetupMakeThis: {
        text: "iPhone14SetupMakeThis",
        image: "iPhone14SetupMakeThisImage",
      },
      iPhone14SetupEnableiMessage: {
        text: "iPhone14SetupEnableiMessage",
        image: "iPhone14SetupEnableiMessageImage",
      },
      iPhone14SetupEnableLocation: {
        text: "iPhone14SetupEnableLocation",
        image: "iPhone14SetupEnableLocationImage",
      },
      iPhone14SetupContinueToSiri: {
        text: "iPhone14SetupContinueToSiri",
        image: "iPhone14SetupContinueToSiriImage",
      },
      iPhone14SetupScreentime: {
        text: "iPhone14SetupScreentime",
        image: "iPhone14SetupScreentimeImage",
      },
      iPhone14SetupShareAnalytics: {
        text: "iPhone14SetupShareAnalytics",
        substep: "iPhone14SetupShareAnalyticsSubstep",
        image: "iPhone14SetupShareAnalyticsImage",
      },
      iPhone14SetupAppearance: {
        text: "iPhone14SetupAppearance",
        image: "iPhone14SetupAppearanceImage",
      },
      iPhone14SetupZoomedDisplay: {
        text: "iPhone14SetupZoomedDisplay",
        image: "iPhone14SetupZoomedDisplayImage",
      },
      iPhone14SetupSOS: {
        text: "iPhone14SetupSOS",
        image: "iPhone14SetupSOSImage",
      },
      iPhone14SetupWelcomeScreen: {
        text: "iPhone14SetupWelcomeScreen",
        image: "iPhone14SetupWelcomeScreenImage",
      },
      iphone14ActivationIMEI: {
        text: "iphone14ActivationIMEI",
        substep: "iphone14ActivationIMEISubstep",
      },
      iPhone14ActivationCallNumber: {
        text: "iPhone14ActivationCallNumber",
        substep: "iPhone14ActivationCallNumberSubstep",
      },
      iPhone14SetupShowInstructionsFor: {
        text: "iPhone14SetupShowInstructionsFor",
      },
      iPhone14SetupTransferringData: {
        image: "iPhone14SetupTransferringDataImage",
      },
      // Samsung Setup
      samsungLanguageSelect: {
        text: "samsungLanguageSelect",
        image: "samsungLanguageSelectImage"
      },
      samsungTermsAndConditions: {
        text: "samsungTermsAndConditions",
        image: "samsungTermsAndConditionsImage",
      },
      samsungCopySettings: {
        text: "samsungCopySettings",
        image: "samsungCopySettingsImage",
      },
      samsungScanQRCode: {
        text: "samsungScanQRCode",
        images: [
          "samsungScanQRCodeImage",
          "samsungContinueOnOldDeviceImage",
        ]
      },
      samsungManualSetupConnectToWiFi: {
        text: "samsungManualSetupConnectToWiFi",
        images: [
          "samsungManualSetupConnectToWiFiImage",
          "samsungManualSetupWiFiPasswordImage"
        ]
      },
      samsungManualSetupDownloadCellularPlan: {
        text: "samsungManualSetupDownloadCellularPlan",
        images: [
          "samsungManualSetupPreparingMobileConnectionImage",
          "samsungManualSetupConnectingToATTNetworkImage",
          "samsungManualSetupConnectToWiFiEndImage"
        ],
      },
      samsungNextStepsHeader: {
        text: "samsungNextStepsHeader"
      },
      samsungGoogleSignInSubheader: {
        text: "samsungGoogleSignInSubheader"
      },
      samsungMakeATestCallSubheader: {
        text: "samsungMakeATestCallSubheader"
      },
      enterYourEmailOrPhone: {
        text: "attSignIntoYourGoogleAccountEnterYourEmailOrPhoneText",
        substep: "attSignIntoYourGoogleAccountEnterYourPasswordText",
        image: "attSignIntoYourGoogleAccountEnterYourEmailOrPhoneImage",
      },
      selectUser: {
        text: "attSignIntoYourGoogleAccountSelectUserText",
        image: "attSignIntoYourGoogleAccountSelectUserImage",
      },
      chooseInfoToCopy: {
        text: "attSignIntoYourGoogleAccountChooseInfoToCopyText",
        image: "attSignIntoYourGoogleAccountChooseInfoToCopyImage",
      },
      selectGoogleServices: {
        text: "attSignIntoYourGoogleAccountSelectGoogleServicesText",
        image: "attSignIntoYourGoogleAccountSelectGoogleServicesImage",
      },
      protectYourPhone: {
        text: "attSignIntoYourGoogleAccountProtectYourPhoneText",
        substep: "attSignIntoYourGoogleAccountSkipAndRevisitText",
        image: "attSignIntoYourGoogleAccountProtectYourPhoneImage",
      },
      accessAssistant: {
        text: "attSignIntoYourGoogleAccountAccessAssistantText",
        image: "attSignIntoYourGoogleAccountAccessAssistantImage",
      },
      followInstructionForAssistant: {
        text: "attSignIntoYourGoogleAccountFollowInstructionForAssistantText",
        image: "attSignIntoYourGoogleAccountFollowInstructionForAssistantImage",
      },
      followInstructionWait: {
        text: "attSignIntoYourGoogleAccountFollowInstructionWaitText",
        image: "attSignIntoYourGoogleAccountFollowInstructionWaitImage",
      },
      addMoreCloudStorage: {
        text: "attSignIntoYourGoogleAccountAddMoreCloudStorageText",
        image: "attSignIntoYourGoogleAccountAddMoreCloudStorageImage",
      },
      attDiagnosticInfo: {
        text: "attSignIntoYourGoogleAccountAttDiagnosticInfoText",
        image: "attSignIntoYourGoogleAccountAttDiagnosticInfoImage",
      },
      rememberItMightTakeMinutes: {
        text: "attSignIntoYourGoogleAccountRememberItMightTakeMinutesText",
        image: "attSignIntoYourGoogleAccountRememberItMightTakeMinutesImage",
      },
      signInToSamsung: {
        text: "attSignIntoYourGoogleAccountSignInToSamsungText",
        substep: "attSignIntoYourGoogleAccountPreferSkipText",
        images: [
          "attSignIntoYourGoogleAccountSignInToSamsungImage1",
          "attSignIntoYourGoogleAccountSignInToSamsungImage2",
          "attSignIntoYourGoogleAccountSignInToSamsungImage3",
        ],
      },
      samsungServices: {
        text: "attSignIntoYourGoogleAccountSamsungServicesText",
        image: "attSignIntoYourGoogleAccountSamsungServicesImage",
      },
      preferredDisplayMode: {
        text: "attSignIntoYourGoogleAccountPreferredDisplayModeText",
        image: "attSignIntoYourGoogleAccountPreferredDisplayModeImage",
      },
      samsungTips: {
        text: "attSignIntoYourGoogleAccountSamsungTipsText",
        image: "attSignIntoYourGoogleAccountSamsungTipsImage",
      },
      finishSignIn: {
        text: "attSignIntoYourGoogleAccountFinishText",
        image: "attSignIntoYourGoogleAccountFinishImage",
      },
      tryMakingCall: {
        text: "attSignIntoYourGoogleAccountTryMakingCallText",
        image: "attSignIntoYourGoogleAccountTryMakingCallImage",
      },
    },
  },
};
